"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotariusClient = exports.NotariusErrorStatus = void 0;

var tslib_1 = require("tslib");

var axios_1 = tslib_1.__importDefault(require("axios"));

var CertificateUtils_1 = require("../CertificateUtils");

var url_parse_1 = tslib_1.__importDefault(require("url-parse"));

var Errors_1 = require("@skbkontur/plugin-js/lib/common/Errors");

var Log_1 = require("@skbkontur/plugin-js/lib/common/Log");

var Parameters_1 = require("../../components/Control/Parameters");

var RequisiteCertificate_1 = require("../../components/RequisiteCertificate");

var config_1 = require("./config");

var constants_1 = require("../../utils/constants");

var NotariusErrorStatus;

(function (NotariusErrorStatus) {
  /** Не удалось авторизовать пользователя по auth.sid */
  NotariusErrorStatus["AuthenticationError"] = "authenticationError";
  /** Не удалось зашифровать секрет на сертификате */

  NotariusErrorStatus["IncorrectRequest"] = "incorrectRequest";
  /** Расшифрованный пользователем секрет не совпал с хранящимся на сервере */

  NotariusErrorStatus["WrongSecret"] = "wrongSecret";
  /** Расшифрованный пользователем секрет устарел */

  NotariusErrorStatus["CodeExpired"] = "codeExpired";
  /** Не квалифицированный сертификат */
  // NotQualifiedCertificate = 'notQualifiedCertificate',

  /** Сертификат отозван */
  // RevokedCertificate = 'revokedCertificate',

  /** Статус ошибки отсутствует */

  NotariusErrorStatus["NoErrorStatus"] = "NoErrorStatus";
})(NotariusErrorStatus = exports.NotariusErrorStatus || (exports.NotariusErrorStatus = {}));

var NotariusClient =
/** @class */
function () {
  function NotariusClient(_a) {
    var _b = _a.sid,
        sid = _b === void 0 ? '' : _b,
        _c = _a.env,
        env = _c === void 0 ? Parameters_1.Env.Prod : _c,
        _d = _a.timeout,
        timeout = _d === void 0 ? config_1.TIMEOUT : _d,
        url = _a.url,
        headers = _a.headers;
    this.log = Log_1.LogManager.getLog(constants_1.LOG_PREFIX + "NotariusClient");
    var apiUrl = url !== null && url !== void 0 ? url : this.getExternalUrl();
    var requestHeaders = headers;

    if (!requestHeaders) {
      var apiKey = env === Parameters_1.Env.Prod ? config_1.PROD_APIKEY : config_1.DEV_APIKEY;
      requestHeaders = {
        'X-Kontur-Apikey': apiKey,
        'Content-Type': 'application/json'
      };

      if (sid) {
        requestHeaders['Authorization'] = "auth.sid " + sid;
      }
    }

    this.axios = axios_1.default.create({
      baseURL: apiUrl,
      timeout: timeout,
      headers: requestHeaders,
      withCredentials: !sid
    });
    this.axios.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      if (error.response) {
        var response = error.response;
        var _a = response.data,
            errorStatus = _a.errorStatus,
            errorMessages = _a.errorMessages;
        var msg = response.status + " " + response.statusText + "." + ("ErrorStatus: " + errorStatus + ". Messages: " + (errorMessages || []).join());
        return Promise.reject(new Errors_1.CommonError(msg, null, errorStatus || NotariusErrorStatus.NoErrorStatus));
      } else {
        return Promise.reject(new Errors_1.CommonError(error.message, null, CertificateUtils_1.HttpStatus.NetworkError, null, error));
      }
    });
  }

  NotariusClient.prototype.getUserCertificates = function (types) {
    var _this = this;

    var config = {
      params: {
        types: types
      }
    };
    return this.axios.get('/users/certs', config).then(function (response) {
      return _this.processRequisiteCertificates(response.data.certs);
    }).catch(function (error) {
      _this.log.error("Method getUserCertificates. Message: " + error.message);

      throw error;
    });
  };

  NotariusClient.prototype.privateKeyCheck = function (base64) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      var response, error_1;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , this.axios.post('/users/certs/check', {
              rawData: base64
            })];

          case 1:
            response = _a.sent();
            return [2
            /*return*/
            , response.data.encryptedContent];

          case 2:
            error_1 = _a.sent();
            this.log.error("Method privateKeyCheck. Message: " + error_1.message);
            throw error_1;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  NotariusClient.prototype.privateKeyApprove = function (thumbprint, decryptedToken) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
      var error_2;
      return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , this.axios.post("/users/certs/" + thumbprint + "/approve", {
              thumbprint: thumbprint,
              secret: decryptedToken
            })];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];

          case 2:
            error_2 = _a.sent();
            this.log.error("Method checkDecryptedToken. Message: " + error_2.message);
            throw error_2;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  NotariusClient.prototype.getExternalUrl = function () {
    var url = new url_parse_1.default(window.location.href);
    var hostParts = url.hostname.split('.');
    return "https://api." + hostParts.slice(-2).join('.') + "/" + config_1.API_NAME + "/" + config_1.API_VERSION;
  };

  NotariusClient.prototype.processRequisiteCertificates = function (rawCertificates) {
    return rawCertificates.map(function (raw) {
      return new RequisiteCertificate_1.RequisiteCertificate(raw);
    });
  };

  return NotariusClient;
}();

exports.NotariusClient = NotariusClient;